import styled from 'styled-components';
import { colors, spacing } from 'syf-component-library/defaultTheme';
import { Body } from 'syf-component-library/ui/typography';
import { CardRowCLWrapper } from '../../../../molecules/PaymentModalStates/subcomponents';
const CARD_LEFT_PADDING = 60;
const CARD_BOTTOM_PADDING = 25;
const LINE_WIDTH = spacing.xsmall;
const LINE_LEFT_PADDING = CARD_LEFT_PADDING / 2 - LINE_WIDTH / 2 + 1;
const CIRCLE_SIZE = spacing.large;
const LINE_TOP_PADDING = CIRCLE_SIZE + CARD_BOTTOM_PADDING;
const CIRCLE_LEFT_PADDING = CARD_LEFT_PADDING / 2 - CIRCLE_SIZE / 2;
export const MultiPaymentListWrapper = styled.div `
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;
export const CardWrapper = styled.div `
  border-radius: ${spacing.base}px;
  background-color: #f9f9f9;
  position: relative;
  padding: ${spacing.base}px ${spacing.base}px ${CARD_BOTTOM_PADDING}px
    ${CARD_LEFT_PADDING}px;
`;
export const NumberCircle = styled.div `
  width: ${CIRCLE_SIZE}px;
  height: ${CIRCLE_SIZE}px;
  left: ${CIRCLE_LEFT_PADDING}px;
  border-radius: 50%;
  border: ${(props) => props.success ? `1px solid ${colors.success}` : '1px solid #34657f'};
  background-color: ${(props) => props.success ? colors.success : 'transparent'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
  color: ${(props) => (props.success ? colors.white : '#34657f')};
  position: absolute;
`;
export const PaymentScheduleWrapper = styled.div `
  border-radius: 5px;
  padding-bottom: 12px;
`;
export const PaymentLeftLine = styled.div `
  margin-bottom: 20px;
  width: ${LINE_WIDTH}px;
  background-color: ${(props) => (props.success ? colors.success : '#acd3d7')};
  border-radius: 2px;
  position: absolute;
  top: ${LINE_TOP_PADDING}px;
  bottom: -30px;
  left: ${LINE_LEFT_PADDING}px;
  z-index: 1;
`;
export const PaymentCardWithLineWrapper = styled.div `
  padding-bottom: ${spacing.large}px;
  position: relative;

  &:last-child {
    ${PaymentLeftLine} {
      display: none;
    }
  }
`;
export const PaymentAmountWrapper = styled.div `
  display: flex;
  align-items: center;
  gap: ${spacing.small}px;
`;
export const PaymentHeader = styled(Body) `
  margin-bottom: ${spacing.base}px;
`;
export const CardRowWrapper = styled(CardRowCLWrapper) `
  margin-bottom: ${spacing.base}px;
`;
